import axios from "axios";

export const getBackendBaseURL = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://api.growezy.club/";
  } else {
    return "http://localhost:3001/";
  }
};

export const getAdminFrontendURL = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://app.growezy.club";
  } else {
    return "http://localhost:3002";
  }
};

export const getLoginURL = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://login.growezy.club";
  } else {
    return "http://localhost:5001";
  }
};

export default axios.create({
  baseURL: getBackendBaseURL(),
});
